import { api } from '@/lib/api'
import type { APIResponse } from '@/types/api'
import type { HourType } from '@/types/hour-type'

export interface CreateHourTypeData {
	companyID: string
	code: string
	name: string
	computable: boolean
}

export interface UpdateHourTypeData {
	id: string
	code: string
	companyID: string
	name?: string
	computable?: boolean
}

/**
 * Servicio para gestionar tipos de hora
 */
export class HourTypesService {
	/**
	 * Obtiene todos los tipos de hora de una empresa
	 */
	static async getHourTypesByCompany(companyID: string): Promise<HourType[]> {
		const response = await api.get<APIResponse<HourType[]>>(`/hour-types`, {
			params: { companyID },
		})
		const apiResponse = response.data

		if (!apiResponse.success || !apiResponse.data) {
			throw new Error(apiResponse.message || 'Error al obtener tipos de hora')
		}

		return apiResponse.data
	}

	/**
	 * Crea un nuevo tipo de hora
	 */
	static async createHourType(data: CreateHourTypeData): Promise<HourType> {
		const response = await api.post<APIResponse<HourType>>(`/hour-types`, data)
		const apiResponse = response.data

		if (!apiResponse.success || !apiResponse.data) {
			throw new Error(apiResponse.message || 'Error al crear tipo de hora')
		}

		return apiResponse.data
	}

	/**
	 * Actualiza un tipo de hora
	 */
	static async updateHourType(data: UpdateHourTypeData): Promise<HourType> {
		const response = await api.put<APIResponse<HourType>>('/hour-types', data)
		const apiResponse = response.data

		if (!apiResponse.success || !apiResponse.data) {
			throw new Error(apiResponse.message || 'Error al actualizar tipo de hora')
		}

		return apiResponse.data
	}

	/**
	 * Elimina un tipo de hora
	 */
	static async deleteHourType(id: string): Promise<void> {
		const response = await api.delete<APIResponse<void>>(`/hour-types?id=${id}`)
		const apiResponse = response.data

		if (!apiResponse.success) {
			throw new Error(apiResponse.message || 'Error al eliminar tipo de hora')
		}
	}
}
